import React, { useEffect, useState, Fragment } from 'react';
import Barcode from '../Barcode/Barcode';
import classes from './OfferDetails.module.scss';
import Button from '../../UI/Button/Button';
import moment from 'moment';
import Loader from '../../UI/Loader/Loader';
import { useSelector } from 'react-redux';

const OfferDetails = (props) => {
    const { hasTimer, hideAt, limitSeconds } = props;
    const [barcodeMessage, setBarcodMessage] = useState(false);
    const [showCountdown, setShowCountdown] = useState(false);

    const [days, setDays] = useState('');
    const [hours, setHours] = useState('');
    const [minutes, setMinutes] = useState('');
    const [seconds, setSeconds] = useState('');
    const content = useSelector((state) => state.content);
    useEffect(()=> {
        const setZeros = (num, f) => {
            let n = String(num / 100).slice(2);
            return n.length === 0 && f?.length === 2 ? '00' : n.length === 1 ? n + '0' : n;
        }
        setDays(
            setZeros(
                Math.floor(props.distance / (1000 * 60 * 60 * 24)),
                days
            ),
        );
        setHours(
            setZeros(
                Math.floor((props.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                hours
            )
        );
        setMinutes(
            setZeros(
                Math.floor((props.distance % (1000 * 60 * 60)) / (1000 * 60)),
                minutes
            )
        );
        setSeconds(
            setZeros(
                Math.floor((props.distance % (1000 * 60)) / 1000),
                seconds
            )
        );
    }, [days, hours, minutes, props.distance, seconds]);

    useEffect(() => {
        if (hasTimer) {
            if (hideAt !== 0 && !props.running) {
                let expDate = moment(hideAt);
                props.onSetExpDate(expDate);
                setBarcodMessage(false);
                setShowCountdown(true);
                props.onSetRunning(true)
            } 
            if (props.running) {
                setBarcodMessage(false);
                setShowCountdown(true);
            } else {
                setShowCountdown(false);
                setBarcodMessage(true);
            }
        }
    }, [hasTimer, hideAt, limitSeconds, props])

    const handleTimerStart = () => {
        const expDate = moment().add(limitSeconds, 'seconds');
        props.onSetExpDate(expDate);
        props.onSetRunning(true);
        props.onUpdateStatus(4)
        setBarcodMessage(false)
        setShowCountdown(true);
    }

    let barcode = (
        <div>
            <div className={classes.OfferDetailsModalTitle}>
                Please show the promo code below to an associate in order to redeem. 
            </div>
            {
                showCountdown && (
                    <div className={classes.CountDown}>
                        <p className={classes.CountDownText}>This code is available for
                            <span>
                                {days !== '' && days+':'}{hours !== '' && hours+':'}{minutes !== '' && minutes + ':'}{seconds !== '' && seconds}
                            </span>
                        </p>
                    </div>
                )
            }
            <Barcode
                showCountdown={showCountdown}
                showBarcode={hasTimer ? false : true}
                // handleExpire={handleExpire}
                content={content?.content}>
            </Barcode>
            {/* <div className={classes.BarcodeFooter}>
                <div style={{ height: '26px', width: '26px' }}>
                    <img
                        height='100%'
                        width='100%'
                        src={ScanImg}
                        alt='scan icon'
                    />
                </div>
                <div
                    className={classes.BarcodeFooterCopy}
                    style={{ paddingLeft: '10px' }}>
                    <div>Take a screenshot to save</div>
                    <div>this offer for later use.</div>
                </div>
            </div> */}
        </div>
    );

    const modalIcon = (
        <div className={classes.OfferDetailsModalIconContainer}>
            <img
                className={classes.OfferDetailsModalIcon}
                src={content.content.images.thumbnail.url}
                alt='wallet_icon'
            />
        </div>
    );

    const expMessage = (
        <div>
            <p>This offer has been redeemed or is no longer available. </p>
            <p>Thank you.</p>
        </div>
    )

    return (
        <Fragment>
            {barcodeMessage ? (
                <div style={{maxWidth: '300px'}} className={classes.OfferDetailsModalContainer}>
                    <p className={classes.MessageTitle}>Ready to redeem?</p>
                    <p>This offer may only be used <strong>once</strong> and will be valid for a short time.</p>
                    <p>Please be in-person and ready to show an associate the promo code to redeem this offer.</p>
                    <div>
                        <div style={{width: '260px', margin: '24px 0'}}>
                            <Button
                                backgroundColor={'#DC0000'}
                                onClick={handleTimerStart}
                                btnText={'Show Promo Code'}
                                className={classes.Button}>
                            </Button>
                        </div>
                        <div onClick={props.onClose} className={classes.CloseLink}>
                            Not Ready
                        </div>
                    </div>
                </div>
            ) :
            
            (
                <div
                    id={'copyCodeContainer'}
                    className={classes.OfferDetailsModalContainer}>
                    {modalIcon}
                    {
                        (props.expired === null && hasTimer) ?
                        <Loader style={{margin: '24px'}}/> :
                        props.expired ?
                        expMessage :
                        barcode
                    }
                </div>
            )}
        </Fragment>
    );
};

export default OfferDetails;
